"use client";
import { useContext, useMemo } from "react";
import { MotionContext } from ".";
import { getCurrentTreeVariants } from "./utils";
export function useCreateMotionContext(props) {
    const { initial, animate } = getCurrentTreeVariants(props, useContext(MotionContext));
    return useMemo(() => ({ initial, animate }), [variantLabelsAsDependency(initial), variantLabelsAsDependency(animate)]);
}
function variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}
//# sourceMappingURL=create.js.map